module.exports = "<span>{{parameter.bigDecimalValue|currency}}</span>";